export enum LightsArrangement {
  None = 'none',
  Single = 'single',
  Double = 'double'
}
